import React from 'react';

import { AlertIcon } from 'pages/Landings/components/Icons';
import Paragraph from 'pages/Landings/components/Paragraph';
import TopicContent from 'pages/Landings/components/TopicContent';
import TopicHeading from 'pages/Landings/components/TopicHeading';
import TopicTemplate from 'pages/Landings/components/TopicTemplate';

const Alerts: React.FC = () => {
    return (
        <TopicTemplate
            heading={
                <TopicHeading
                    title="Alerts"
                    description="Stay updated about vulnerabilities that matter to you with real-time push and pull notifications. Trigger actions automatically when new vulnerabilities appear."
                    illustration={<AlertIcon />}
                />
            }
            content={
                <TopicContent link="https://docs.vulners.com/docs/products/alerts/">
                    <Paragraph
                        primary="Precision Without Noise"
                        secondary="Keep teams focused with precise, programmatic subscriptions - from “new critical CVEs” to “issues in products we run” - delivered via webhooks or email on your cadence. Filters for product, severity, keywords, and tags (like RCE or zero-day) cut the noise so only actionable items land in front of engineers."
                    />
                    <Paragraph
                        primary="Automate the First Mile"
                        secondary="Automate the first mile the moment an alert hits. Webhook JSON can open tickets, trigger SOAR playbooks, or kick off patch workflows without human hand-offs. Embed alerts directly in your product to retain users with in-app messages like “This affects your stack - here’s impact + fixes,” all without building your own monitoring code."
                    />
                    <Paragraph
                        primary="Easy to Manage"
                        secondary="At scale, management stays simple. Add or change criteria to deliver tailored early-warning streams, keep stakeholders informed, and make your product the place where risk becomes action."
                    />
                </TopicContent>
            }
        />
    );
};

export default Alerts;
